const INCREMENT_ACTIVE_STEP = 'INCREMENT_ACTIVE_STEP';
const SET_ACTIVE_STEP = 'SET_ACTIVE_STEP';
const DECREMENT_ACTIVE_STEP = 'DECREMENT_ACTIVE_STEP';
const RESET_ACTIVE_STEP = 'RESET_ACTIVE_STEP';
const SET_SELECTED_INPUT_EXAMPLE = 'SET_SELECTED_INPUT_EXAMPLE';
const SET_ETL_EXECUTION_STATUS = 'SET_ETL_EXECUTION_STATUS';
const RESET_SELECTED_INPUT_EXAMPLE = 'RESET_SELECTED_INPUT_EXAMPLE';
const SET_NAMED_GRAPH = 'SET_NAMED_GRAPH';
const SET_SPARQL_ENDPOINT_IRI = 'SET_SPARQL_ENDPOINT_IRI';
const SET_DATA_SAMPLE_IRI = 'SET_DATA_SAMPLE_IRI';
const SET_RDF_RESOURCE_URL = 'SET_RDF_RESOURCE_URL';
const SET_RDF_FILE = 'SET_RDF_FILE';
const SET_RDF_DATA_SAMPLE_FILE = 'SET_RDF_DATA_SAMPLE_FILE';
const SET_ACTIVE_DISCOVER_INPUT_TAB = 'SET_ACTIVE_DISCOVER_INPUT_TAB';
const SET_RDF_URL_DATA_SAMPLE_IRI = 'SET_RDF_URL_DATA_SAMPLE_IRI';

export default {
  INCREMENT_ACTIVE_STEP,
  SET_ACTIVE_STEP,
  DECREMENT_ACTIVE_STEP,
  RESET_ACTIVE_STEP,
  SET_SELECTED_INPUT_EXAMPLE,
  RESET_SELECTED_INPUT_EXAMPLE,
  SET_ETL_EXECUTION_STATUS,
  SET_NAMED_GRAPH,
  SET_SPARQL_ENDPOINT_IRI,
  SET_DATA_SAMPLE_IRI,
  SET_RDF_RESOURCE_URL,
  SET_RDF_FILE,
  SET_RDF_DATA_SAMPLE_FILE,
  SET_ACTIVE_DISCOVER_INPUT_TAB,
  SET_RDF_URL_DATA_SAMPLE_IRI
};
